module.exports = __webpack_public_path__ + "img/toilet.10a1f412.svg";